module.exports = __webpack_public_path__ + "static/media/map.2aec01c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/map.png
// module id = 3732
// module chunks = 0